export default __webpack_public_path__ + "static/media/folder.4b5bfd32.svg";